


















































































































































































































































































































































































































import { MeasuringConceptsFormStepContent } from '@/api/interfaces/content/form/steps/measuringConceptsFormStepContent';
import ButtonSpacer from '@/components/molecules/buttonSpacer/ButtonSpacer.vue';
import FormBooleanCheckbox from '@/components/molecules/formBooleanCheckbox/FormBooleanCheckbox.vue';
import FormField from '@/components/molecules/formField/FormField.vue';
import FormFileUpload from '@/components/molecules/formFileUpload/FormFileUpload.vue';
import FormInputText from '@/components/atoms/formInputText/FormInputText.vue';
import FormRadioGroup from '@/components/molecules/formRadioGroup/FormRadioGroup.vue';
import FormRow from '@/components/molecules/formRow/FormRow.vue';
import FormSelect from '@/components/molecules/formSelect/FormSelect.vue';
import FormTextBlock from '@/components/molecules/formTextBlock/FormTextBlock.vue';
import { getFormStepMixin } from '@/mixins/formStepMixin';
import { MeasuringConceptsFormStep } from '@/types/forms/formSteps/measuringConceptsFormStep';
import { FormStepConfiguration } from '@/api/interfaces/configuration/form/base/formStepConfiguration';
import {
    formatGermanNumber,
    parseGermanFloat,
} from '@/utilities/germanFormats';
import { ApplicationForm } from '@/types/forms/specific/applicationForm';
import { calculateSelfGenerationQuantity } from '@/services/form/utilities/application/plantPerformance';
import { isPv } from '@/services/form/rules/application/common';

const PV_SELFGENERATIONQUANTITY_TO_SELFSUPPLYQUANTITY_FACTOR = 0.7;

export default getFormStepMixin<
    MeasuringConceptsFormStep,
    MeasuringConceptsFormStepContent,
    FormStepConfiguration,
    ApplicationForm
>().extend({
    name: 'MeasuringConcepts',
    components: {
        ButtonSpacer,
        FormBooleanCheckbox,
        FormField,
        FormFileUpload,
        FormInputText,
        FormRadioGroup,
        FormRow,
        FormSelect,
        FormTextBlock,
    },
    watch: {
        'model.operatingMode.value': function () {
            this.updateSelfSupplyQuantity();
        },
        'model.selfGenerationQuantity.value': function () {
            if (this.model.operatingMode.value !== 'fullInfeed') {
                this.updateSelfSupplyQuantity();
            }
        },
    },
    mounted(): void {
        this.initializeSelfGenerationQuantity();
    },
    methods: {
        updateSelfSupplyQuantity(): void {
            let selfSupplyQuantity = 0;
            if (this.model.operatingMode.value !== 'fullInfeed') {
                const selfGenerationQuantity = parseGermanFloat(
                    this.model.selfGenerationQuantity?.value ?? '0',
                );
                selfSupplyQuantity =
                    selfGenerationQuantity *
                    PV_SELFGENERATIONQUANTITY_TO_SELFSUPPLYQUANTITY_FACTOR;
            }
            this.model.selfSupplyQuantity.value = formatGermanNumber(
                selfSupplyQuantity,
                { decimals: 2, thousandsSeparator: true },
            );
            this.$nextTick(() => {
                this.validations?.selfSupplyQuantity.$reset();
                this.rules(this);
            });
        },
        initializeSelfGenerationQuantity(): void {
            if (isPv(this.formModel)) {
                this.model.selfGenerationQuantity.value = calculateSelfGenerationQuantity(
                    this.formModel,
                );
                this.$nextTick(() => {
                    this.validations?.selfGenerationQuantity.$reset();
                });
            }
        },
    },
});
